import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { checkProtocol } from 'core/helpers/checkProtocol';
import LoaderList from './components/LoaderList';
import { ROUTES } from 'commons/routes/routes';
import { Card, Content, List, ListItem, FooterList, Icon, Text } from './styled';
import SdsButton from '../../../../commons/containers/SdsButton'

class CardList extends PureComponent {
	handleClick = url => {
		const { history, handleClose } = this.props;
		if (checkProtocol(url)) {
			return (window.location = url);
		}
		handleClose();
		return history.push({
			pathname: ROUTES.NOTIFICATION.path,
			url: url
		});
	};

	render() {
		const { showPreloader, notifications, handleClose } = this.props;

		return (
			<Card>
				{showPreloader && (
					<Content>
						<LoaderList />
					</Content>
				)}
				{notifications.length ? (
					<Fragment>
						<List>
							{notifications.map(item => (
								<ListItem
									key={item.cdNotificacaoBrowser}
									onClick={() => this.handleClick(item.deUrl)}>
									<Icon className="material-icons">{item.deIcone}</Icon>
									<Text>{item.deMensagem}</Text>
								</ListItem>
							))}
						</List>
						<FooterList>
							<SdsButton
								raised
								onClick={() => handleClose()}
								label="LABELS.COMMONS.NOTIFICACOES.BOTAO.VER_TUDO"
							/>
						</FooterList>
					</Fragment>
				) : (
					!showPreloader && (
						<Content>
							<Text>Nenhuma notificação no momento</Text>
						</Content>
					)
				)}
			</Card>
		);
	}
}

CardList.defaultProps = {
	notifications: {}
};

CardList.propTypes = {
	handleClose: PropTypes.func.isRequired,
	notifications: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};

export default withRouter(CardList);
